export default __webpack_public_path__ + "static/media/deactivated_alarm.485d6d51.mp3";